/*
 * Temporary hotfix for Flare PDP add-to-cart guard.
 * Remove this file and its theme.liquid include after Flare ships a fix.
 */
(function () {
  if (window.__flarePdpAddToCartHotfixInstalled) return;
  window.__flarePdpAddToCartHotfixInstalled = true;

  var ADD_BUTTON_SELECTOR = [
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] [name="add"]',
    'form[action*="/cart/add"] input[type="submit"]',
    '.single-add-to-cart-button'
  ].join(',');
  var CART_ADD_FORM_SELECTOR = 'form[action*="/cart/add"]';
  var FLARE_READY_TIMEOUT = 10000;
  var startedAt = Date.now();
  var observer = null;
  var scheduled = false;

  function isElement(target) {
    return target && target.nodeType === 1;
  }

  function closestAddButton(target) {
    return isElement(target) ? target.closest(ADD_BUTTON_SELECTOR) : null;
  }

  function cartAddForm() {
    return document.querySelector(CART_ADD_FORM_SELECTOR);
  }

  function owningCartAddForm(button) {
    var form = button ? button.form || button.closest(CART_ADD_FORM_SELECTOR) : null;

    return form && form.matches(CART_ADD_FORM_SELECTOR) ? form : null;
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isProductFormReady() {
    var form = cartAddForm();
    var variantInput = form ? form.querySelector('[name="id"]') : null;

    return !!(form && variantInput && variantInput.value && !variantInput.disabled);
  }

  function isFlareReady() {
    var flareContainer = document.querySelector('.flare-date-picker-container');

    if (!flareContainer) return true;
    if (flareContainer.classList.contains('flare-initialized')) return true;

    return Date.now() - startedAt > FLARE_READY_TIMEOUT;
  }

  function isReadyForCartAdd() {
    if (Date.now() - startedAt > FLARE_READY_TIMEOUT) return true;

    return document.readyState !== 'loading' && isProductFormReady() && isFlareReady();
  }

  function hasSelectedFlareDate() {
    var dateInput = document.querySelector('#ship-date');

    if (!dateInput) return false;
    if (dateInput.value) return true;
    if (dateInput._flatpickr && Array.isArray(dateInput._flatpickr.selectedDates)) {
      return dateInput._flatpickr.selectedDates.length > 0;
    }

    return false;
  }

  function isFlareActivelyBlocking() {
    var globalConfig = window.flareGlobalConfig || {};
    var flareBlock = document.querySelector('#flare-date-picker-block');
    var flareContainer = document.querySelector('.flare-date-picker-container');
    var dateWrapper = document.querySelector('#date-selector-wrapper');

    if (globalConfig.blockCheckoutWithoutDate === false) return false;
    if (!flareBlock && !flareContainer && !dateWrapper) return false;
    if (flareBlock && (flareBlock.dataset.flarePickerIneligible === 'true' || !isVisible(flareBlock))) return false;
    if (flareContainer && !isVisible(flareContainer)) return false;
    if (document.querySelector('.flare-pdp-add-to-cart-guard-message')) return true;
    if (dateWrapper && (dateWrapper.classList.contains('flare-required-date-missing') || dateWrapper.getAttribute('aria-invalid') === 'true')) return true;
    if (dateWrapper && isVisible(dateWrapper) && !dateWrapper.classList.contains('enabled')) return true;

    return !!(dateWrapper && isVisible(dateWrapper) && !hasSelectedFlareDate());
  }

  function hasFlareInlineDisabledStyle(button) {
    return button.style.pointerEvents === 'auto' &&
      button.style.getPropertyPriority('pointer-events') === 'important' &&
      button.style.opacity === '0.5' &&
      button.style.cursor === 'not-allowed' &&
      button.style.getPropertyPriority('cursor') === 'important';
  }

  function isSoldOutButton(button) {
    return button.classList.contains('sold-out') || /sold out|udsolgt/i.test(button.textContent || '');
  }

  function restoreButton(button) {
    if (!button || isSoldOutButton(button) || button.classList.contains('loading')) return;
    if (!hasFlareInlineDisabledStyle(button)) return;
    if (!isReadyForCartAdd() || isFlareActivelyBlocking()) return;

    if ('disabled' in button) button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('tabindex');
    button.style.removeProperty('pointer-events');
    button.style.removeProperty('opacity');
    button.style.removeProperty('cursor');
  }

  function restoreButtons() {
    document.querySelectorAll(ADD_BUTTON_SELECTOR).forEach(restoreButton);
  }

  function scheduleRestore() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      restoreButtons();
    });
  }

  function blockEarlyCartAdd(event) {
    var button = closestAddButton(event.target);

    if (!button || !owningCartAddForm(button)) return;
    if (isReadyForCartAdd()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scheduleRestore();
  }

  function blockEarlySubmit(event) {
    if (!event.target || !event.target.matches(CART_ADD_FORM_SELECTOR)) return;
    if (isReadyForCartAdd()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scheduleRestore();
  }

  function startObserver() {
    if (observer || !document.body || typeof MutationObserver === 'undefined') return;

    observer = new MutationObserver(scheduleRestore);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'disabled', 'aria-disabled', 'tabindex', 'class']
    });
    scheduleRestore();
  }

  document.addEventListener('click', blockEarlyCartAdd, true);
  document.addEventListener('submit', blockEarlySubmit, true);

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  }

  window.addEventListener('load', scheduleRestore);
  window.setTimeout(scheduleRestore, FLARE_READY_TIMEOUT + 100);
})();
